/**
 * English voice of the IELTS screens (speechSynthesis, en-GB first): Listening scripts without a
 * generated audio, the Speaking examiner, the pronunciation of the vocabulary cards. The choice of
 * the voice and the text read (`spokenScript`) are shared with the phone in @agencyos/core.
 */

import { ENGLISH_VOICE, pickEnglishVoice } from "@agencyos/core";

import { deviceVoices, speechAvailable, stopSpeaking, utter } from "../audio";

/** Read an English text aloud once; resolves when finished (or at once without speech support).
 * Read in short pieces with a watchdog (`utter`): a long text never hangs (D-114). */
export async function speakEnglish(text: string, rate = 0.95): Promise<void> {
  if (!speechAvailable() || !text.trim()) return;
  const voice = pickEnglishVoice(await deviceVoices());
  stopSpeaking();
  await utter(text, { lang: voice?.lang ?? ENGLISH_VOICE, voice, rate });
}
